const scene = "course-add";

export const UPDATE_COURSE = `${scene}UPDATE_COURSE`;

